import { useAuthStore } from 'store/useAuthStore';
import { AdminAction, ModuleKey } from 'types/adminTypes';
import { User } from 'types/auth';

export const canAccess = (module: ModuleKey, action: AdminAction) => {
  const { user } = useAuthStore.getState();
  const moduleInList = user?.permission_list.find((item) => item.module === module);
  if (moduleInList) {
    return moduleInList.actions.includes(action);
  }
  return false;
};

export const getAllowedModules = (user: User | null) => {
  const allowedModules: ModuleKey[] = [];
  user?.permission_list.forEach((m) => allowedModules.push(m.module));
  return allowedModules;
};
